import { AxiosResponse } from 'axios';
import { pregame } from '@/api/pregame';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams, IPregameApiListResponse, IPregameFilters } from '@/types';

export const pregameService = {
    async list(params: IListParams<IPregameFilters>): Promise<AxiosResponse<IPregameApiListResponse>> {
        try {
            const response = await baseListService<IPregameApiListResponse>(pregame, params);
            return response;
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            throw new AppError(`Unable to load pregame list, request error`, { cause: e });
        } finally {
        }
    },
};
